import { Button } from '@/components/Button'
import { Icon } from '@/components/Icon'
import { showImagePreview as show } from '@/components/ImagePreview'

export const useImagePreview = () => {
  const route = useRoute()
  const router = useRouter()
  const store = useStore()

  const onFindSimilar = (image, offerId) => {
    store.commit('h5Module/closeImageSearchDialog')
    nextTick(() => {
      store.commit('h5Module/showImageSearchDialog', {
        type: 'similar',
        imageUrl: image,
        imageId: 0
      })

      const url = `/search?offerId=${offerId}&type=similar`
      if (route.fullPath.includes('imageId')) {
        router.replace(url)
      } else {
        router.push(url)
      }
    })
  }

  const showImagePreviewWithSimilar = ({
    images, startPosition, offerId
  }) => {
    const { close } = show({
      images,
      startPosition,
      options: {
        slots: {
          footer: ({ current }) => h(
            Button,
            {
              class: 'image-preview-button',
              block: false,
              onClick: () => {
                onFindSimilar(images[current], offerId)
                close()
              }
            },
            () => [
              h(Icon, { name: 'icon-image-search-similar', class: 'image-preview-button__icon' }),
              'Find Similar'
            ]
          )
        }
      }
    })
  }

  return {
    showImagePreviewWithSimilar
  }
}
